// packages
import { createContext, useContext, useEffect, useState } from 'react'

// store
import { useAuthStore } from '@/store/auth'
import { useLocation, useNavigate, useParams } from 'react-router-dom'

// variables
const AuthContext = createContext<{ loading: boolean }>({ loading: true })

export const AuthProvider = ({ children }: { children: React.ReactNode }) => {
  const { user, token, logout, isAuthenticated } = useAuthStore()
  const { ref } = useParams()
  const navigate = useNavigate()
  const [isLoading, setIsLoading] = useState(false)
  const location = useLocation();
  const from = location.state?.from?.pathname || "/";


/*   useEffect(() => {
    const authenticated = !!(user || token || isAuthenticated)

    // if (!authenticated && !['/chat'].includes(location.pathname)) {
    //   navigate(`/login`)
    // }


    if (!authenticated && !['/', '/401', '/404', '/login'].includes(location.pathname)) {
      logout()
      return
    } else if (authenticated && ['/', '/401', '/404', '/login'].includes(location.pathname)) return
    else if (authenticated) return
  }, [user, token, isAuthenticated]) */

  useEffect(() => {
    setIsLoading(false)
  }, [])

  return <AuthContext.Provider value={{ loading: isLoading }}>{children}</AuthContext.Provider>
}

export const useAuth = () => {
  const context = useContext(AuthContext)
  if (!context) throw new Error('useAuth must be used within an AuthProvider')
  return context
}
